import React from "react";
import { DEFAULT_MARKUP, MARKUPS } from "@/lib/solitairePricing";

// Silent 3-dot markup selector. No tooltips, no labels — colour is the only signal.
// Magenta = no markup, Purple = +15, Navy = +20.
export default function MarkupDots({ value = DEFAULT_MARKUP, onChange }) {
  const dots = [
    { key: "magenta", color: "#D946EF" },
    { key: "purple",  color: "#8B5CF6" },
    { key: "navy",    color: "#1E3A8A" },
  ];
  return (
    <div className="flex items-center gap-1.5" data-testid="markup-dots">
      {dots.map((d) => {
        const active = value === d.key;
        return (
          <button
            key={d.key}
            type="button"
            onClick={() => onChange?.(d.key)}
            data-testid={`markup-dot-${d.key}`}
            aria-pressed={active}
            aria-label=""
            className="rounded-full transition-all duration-200 focus:outline-none"
            style={{
              width: active ? 10 : 7,
              height: active ? 10 : 7,
              background: d.color,
              boxShadow: active ? `0 0 0 1.5px rgba(255,255,255,0.95), 0 0 0 2.5px ${d.color}` : "none",
              opacity: active ? 1 : 0.55,
              cursor: "pointer",
            }}
          />
        );
      })}
    </div>
  );
}
